export default {
  listCategory: [],
  listProduct: [],
  listAttribute: [],
  accessToken: localStorage.getItem('accessToken'),
}
